import React, { useState, useContext } from "react";
import { withRouter, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import OtpInput from "react-otp-input";
import Typography from "../../../common/typography/index.component";
import { useTranslation } from "react-i18next";
import analyticsPubSub, {
  ANALYTICS_EVENTS,
} from "common/services/analyticsPubSub";
import upsdkService from "common/services/upsdkService";
import { showNotification } from "../../../helpers/utils";
import ScreenHelper from "../../../helpers/screen.helper";
import { BaseContext } from "../../../context/BaseContext";
import { userLogin } from "common/store/actions/auth";
import Loader from "../../../common/loader/index.component";
// import EditIcon from "../../../assets/icons/edit.icon";
import useRouteHook from "../../../hooks/useRoute.hook";

import "./index.component.scss";

function OtpVerify({
  secondaryTextColor,
  primaryColor,
  authResponse,
  hideAuthDialogCallback,
  resendOtpClickCallback,
  activeAuthFlow,
  primaryLogin,
}) {
  const [value, setValue] = useState("");
  const [timeout, setTimeout] = useState(null);
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const location = useLocation();
  const { menuRoute } = useContext(BaseContext);
  const { historyPush } = useRouteHook();
  let otp_length = 6;

  if (!authResponse) {
    return null;
  }

  const { customer_phone, customer_email } = authResponse;

  const handleResendOtpClick = () => {
    if (timeout != null) {
      return;
    }
    resendOtpClickCallback(customer_phone, customer_email).then(() => {
      startOTPTimer();
    });
  };

  const handleChange = (otp) => {
    setValue(otp);
    if (otp.length === otp_length) {
      handleOtpOnComplete({ ...authResponse, otp });
    }
  };

  const startOTPTimer = () => {
    if (timeout != null) return;
    let sec = 30;
    const intervalTimer = setInterval(() => {
      sec = sec - 1;
      setTimeout(sec);
      if (sec === 0) {
        setTimeout(null);
        clearInterval(intervalTimer);
      }
    }, 1000);
  };

  const handleOtpVerifyFailure = (e) => {
    showNotification(e.message, "error");
  };

  const handleOtpVerifySuccess = () => {
    hideAuthDialogCallback(true);
    if (ScreenHelper.isReferralScreen(location.pathname)) {
      historyPush(menuRoute);
    }
    upsdkService.updateCartOnLogin();
  };

  const submitOTPforSocialAuth = (params) => {
    return upsdkService
      .verifyPhone(params)
      .then(() => {
        handleOtpVerifySuccess();
      })
      .catch((e) => {
        handleOtpVerifyFailure(e);
      });
  };

  const submitEmailOTPforAuth = (email, otp) => {
    return upsdkService
      .submitEmailOTP(email, otp)
      .then((response) => {
        handleOtpVerifySuccess();
        userLogin(response);
        if (activeAuthFlow === "login") {
          const eventObj = {
            ...response,
            success: true,
            username: email,
            social_auth: "NA",
          };

          analyticsPubSub.publish(ANALYTICS_EVENTS.LOGIN_SUCCESS, eventObj);
        } else {
          const eventObj = {
            username: email,
            social_auth: "NA",
          };

          analyticsPubSub.publish(ANALYTICS_EVENTS.SIGNUP_COMPLETE, eventObj);
        }
        return response;
      })
      .catch((error) => {
        handleOtpVerifyFailure(error);
        if (activeAuthFlow === "login") {
          const eventObj = {
            success: false,
            username: email,
            social_auth: "NA",
          };
          analyticsPubSub.publish(ANALYTICS_EVENTS.LOGIN_FAILED, eventObj);
        }
        return error;
      });
  };

  const submitOTPforAuth = (isd_code, customer_phone, otp) => {
    return upsdkService
      .submitOTP(isd_code, customer_phone, otp)
      .then((response) => {
        handleOtpVerifySuccess();
        userLogin(response);
        if (activeAuthFlow === "login") {
          const eventObj = {
            ...response,
            success: true,
            username: customer_phone,
            social_auth: "NA",
          };

          analyticsPubSub.publish(ANALYTICS_EVENTS.LOGIN_SUCCESS, eventObj);
        } else {
          const eventObj = {
            username: customer_phone,
            social_auth: "NA",
          };

          analyticsPubSub.publish(ANALYTICS_EVENTS.SIGNUP_COMPLETE, eventObj);
        }
        return response;
      })
      .catch((error) => {
        handleOtpVerifyFailure(error);
        if (activeAuthFlow === "login") {
          const eventObj = {
            success: false,
            username: customer_phone,
            social_auth: "NA",
          };
          analyticsPubSub.publish(ANALYTICS_EVENTS.LOGIN_FAILED, eventObj);
        }
        return error;
      });
  };

  const handleOtpOnComplete = (params) => {
    setLoading(true);
    const { isd_code, customer_phone, otp, customer_email } = params;
    if (primaryLogin === "email") {
      submitEmailOTPforAuth(customer_email, otp).finally(() =>
        setLoading(false),
      );
    } else if (activeAuthFlow === "social") {
      submitOTPforSocialAuth(params).finally(() => setLoading(false));
    } else {
      submitOTPforAuth(isd_code, customer_phone, otp).finally(() =>
        setLoading(false),
      );
    }
  };

  // const handleEditNumber = () => {
  //   if (activeAuthFlow === "signup") {
  //     handleSetView("signUp");
  //   } else {
  //     handleSetView("signIn");
  //   }
  // };

  return (
    <div className="otp-verification-form">
      <div className="dialog-header">
        <Typography
          variant="h2"
          weight="regular"
          className="form-sub-heading"
          fontColor={secondaryTextColor}
        >
          {t("authDialog.otpVerificationSubHeading", {
            phoneNumber: customer_phone,
          })}
        </Typography>
        {/* <EditIcon
          className="phone-edit-icon"
          size={{ width: "16px", height: "16px" }}
          fill={primaryColor}
          onClickCallback={handleEditNumber}
        /> */}
      </div>
      <div className="dialog-content">
        <OtpInput
          isInputNum={true}
          value={value}
          className="dialog-otp-box"
          shouldAutoFocus={true}
          onChange={handleChange}
          numInputs={otp_length}
          separator={<span>&nbsp; &nbsp;</span>}
        />
      </div>
      <div className="dialog-footer">
        {timeout ? (
          <div className="resend-otp-wrapper">
            <Typography
              variant="h3"
              weight="regular"
              className="resend-now-cta"
              fontColor={secondaryTextColor}
            >
              {t("authDialog.resendOtpIn")}
            </Typography>
            <Typography
              variant="h3"
              weight="semiBold"
              className="resend-now-cta"
              fontColor={primaryColor}
            >
              {timeout}
            </Typography>
          </div>
        ) : (
          <div className="resend-otp-wrapper">
            <Typography
              variant="h3"
              weight="regular"
              className="resend-otp-text"
              fontColor={secondaryTextColor}
            >
              {t("authDialog.resendOtpHelperText")}
            </Typography>
            <Typography
              variant="h3"
              weight="semiBold"
              className="resend-now-cta"
              fontColor={primaryColor}
              onClickCallback={handleResendOtpClick}
            >
              {t("authDialog.resendNow")}
            </Typography>
          </div>
        )}
        <div className="otp-verification-loader">
          {loading && <Loader loaderColor={primaryColor} />}
        </div>
      </div>
    </div>
  );
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      userLogin: userLogin,
    },
    dispatch,
  );

export default withRouter(connect(null, mapDispatchToProps)(OtpVerify));
